{ avatarDomain } = require '@trello/config'
t = require('app/scripts/views/internal/teacup-with-helpers')('member')

module.exports = t.renderable ({ id, avatarHash, viewTitle, initials, isDeactivated, isBoardAdmin, isOrganizationAdmin, hideBadges }) ->
  if avatarHash
    t.img '.member-avatar', {
      height: '30'
      width: '30'
      src: [avatarDomain, avatarHash, '30.png'].join('/')
      srcset:
        [
          [avatarDomain, avatarHash, '30.png 1x'].join('/')
          [avatarDomain, avatarHash, '50.png 2x'].join('/')
        ].join(', ')
      alt: viewTitle,
      title: viewTitle,
    }
  else
    t.span '.member-initials',
      title: viewTitle
      'aria-label': viewTitle
    , ->
      t.text initials

  if id
    t.span "##{id}-avatar"

  if !isDeactivated && !hideBadges
    if isBoardAdmin
      t.span '.member-type.admin', { title: t.l('this-member-is-an-admin-of-this-board'), 'aria-label': t.l('this-member-is-an-admin-of-this-board') }
    if isOrganizationAdmin
      t.span '.member-type.admin', { title: t.l('this-member-is-an-admin-of-this-organization'), 'aria-label': t.l('this-member-is-an-admin-of-this-organization') }

  if !hideBadges
    t.span '.member-gold-badge', { title: t.l('this-member-has-trello-gold'), 'aria-label': t.l('this-member-has-trello-gold') }
